/* 系统管理 */
const layoutComponent = () => import('@/views/layout')

export default [
  {
    path: '/adminManagement',
    component: layoutComponent,
    meta: {
      title: 'menu.adminManagement',
      icon: 'el-icon-ali-gerenzhongxinwoderenwubiaozhuntoumianxing'
    },
    children: [
      {
        path: '/adminManagement/userList',
        name: 'userList',
        component: () => import('@/views/adminManagement/userList'),
        meta: {
          title: 'menu.accountManagement',
          buttons: [
            { code: 'scan', name: '浏览' },
            { code: 'add', name: '新增' },
            { code: 'delete', name: '删除' },
            { code: 'edit', name: '编辑' },
            { code: 'view', name: '查看' },
            { code: 'enable', name: '启用' },
            { code: 'disable', name: '禁用' },
            { code: 'reset', name: '重置' },
            { code: 'authorize', name: '授权' }
          ]
        }
      },
      {
        path: '/adminManagement/userListAdd',
        name: 'userListAdd',
        component: () => import('@/views/adminManagement/userListAdd'),
        meta: {
          title: 'menu.accountManagementDetails',
          routeNameParent: 'userList'
        }
      },
      {
        path: '/adminManagement/systemPermissions',
        name: 'systemPermissions',
        component: () => import('@/views/adminManagement/systemPermissions'),
        meta: {
          title: 'menu.privilegeManagement',
          routeNameParent: 'userList'
        }
      },
      {
        path: '/adminManagement/roleList',
        name: 'roleList',
        component: () => import('@/views/adminManagement/roleList'),
        meta: {
          title: 'menu.roleManagement'
        }
      },
      {
        path: '/adminManagement/roleListAdd',
        name: 'roleListAdd',
        component: () => import('@/views/adminManagement/roleListAdd'),
        meta: {
          title: 'menu.roleManagementDetails',
          routeNameParent: 'roleList'
        }
      },
      {
        path: '/adminManagement/roleGrantAuthorization',
        name: 'roleGrantAuthorization',
        component: () => import('@/views/adminManagement/roleGrantAuthorization'),
        meta: {
          title: 'menu.roleGrantAuthorization',
          routeNameParent: 'roleList'
        }
      },
      {
        path: '/adminManagement/jurisdiction',
        name: 'jurisdiction',
        component: () => import('@/views/adminManagement/jurisdiction'),
        meta: {
          title: '管理员配置权限',
          routeNameParent: 'jurisdiction'
        }
      },
      {
        path: '/adminManagement/adminNoticeListView',
        name: 'adminNoticeListView',
        component: () => import('@/views/adminManagement/adminNoticeListView'),
        meta: {
          title: 'menu.messageManagement'
        }
      },
      {
        path: '/adminManagement/adminSendMessageView',
        name: 'adminSendMessageView',
        component: () => import('@/views/adminManagement/adminSendMessageView'),
        meta: {
          title: '发送消息',
          routeNameParent: 'adminNoticeListView'
        }
      },
      {
        path: '/adminManagement/dataDictionary',
        name: 'dataDictionary',
        component: () => import('@/views/adminManagement/dataDictionary'),
        meta: {
          title: 'menu.dataDictionary'
        }
      },
      {
        path: '/adminManagement/dataDictionaryAdd',
        name: 'dataDictionaryAdd',
        component: () => import('@/views/adminManagement/dataDictionaryAdd'),
        meta: {
          title: 'menu.dataDictionaryDetails',
          routeNameParent: 'dataDictionary'
        }
      },
      
    ]
  }
]
